import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { AffiliateLayout } from './index';
import styled from 'styled-components';
import { useAffiliateTheme } from '../../context/AffiliateThemeContext';

/**
 * Composant pour protéger les routes qui nécessitent une authentification
 * Redirige vers la page de connexion si l'utilisateur n'est pas connecté
 */
const PrivateRoute = ({ element: Element, showHeader = true, showFooter = true }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <AffiliateLayout showHeader={showHeader} showFooter={showFooter}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '50vh' 
        }}>
          <LoadingSpinner />
        </div>
      </AffiliateLayout>
    );
  }

  return authenticated ? (
    <AffiliateLayout showHeader={showHeader} showFooter={showFooter}>
      <Element />
    </AffiliateLayout>
  ) : (
    <Navigate to="/affiliate/login" replace />
  );
};

// Composant d'animation de chargement
const LoadingSpinner = () => {
  // Utiliser le hook pour accéder au thème
  const theme = useAffiliateTheme();
  
  return (
    <SpinnerContainer>
      <Spinner primaryColor={theme.affiliate.colors.primary} />
    </SpinnerContainer>
  );
};

// Styles pour le spinner
const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid ${props => props.primaryColor || '#504099'};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export default PrivateRoute;